export default {
  notSupported: 'Správa receptúr nie je dostupná pre tento typ pece.',
};
